var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"a12872b231e328717c5b1a98235e35df968c556a"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["nextjs@iksel"]={id:"a12872b231e328717c5b1a98235e35df968c556a"};
      